//#region Typedefs

/**
 * @typedef {object} HcpSearchResultsDtoPartial
 * @property {number} buyCount
 * @property {number} buyCount
 * @property {HcpSearchResult[]} value
 * @property {{[key: string]: string[]}} errors
 * @property {string} postalCode
 * @property {number} distance
 * @property {number} page
 */

/**
 * @typedef {HcpSearchResultsDtoPartial & Record<'@odata.count', number> & Record<'value', HcpSearchResult[]>} HcpSearchResultsDto
 */

/**
 * @typedef {object} HcpSearchResultResultsDtoPartial
 * @property {number} buyCount
 * @property {HcpSearchResult[]} value
 * @property {{[key: string]: string[]}} errors
 * @property {string} postalCode
 * @property {number} distance
 * @property {number} page
 */

/**
 * @typedef {HcpSearchResultResultsDtoPartial & Record<'@odata.count', number> & Record<'@search.facets', HcpSearchFacetsResultsDto>} HcpSearchResultResultsDto
 */

/**
 * @typedef {object} HcpSearchFacetsResultsDtoPartial
 * @property {HcpSearchFacetDto[]} marketCodes
 * @property {HcpSearchFacetDto[]} purchasingOptions
 */

/**
 * @typedef {HcpSearchFacetsResultsDtoPartial & Record<'purchasingOptionsV2/salesChannel', HcpSearchFacetDto[]>} HcpSearchFacetsResultsDto
 */

/**
 * @typedef {object} HcpSearchFacetDto
 * @property {number} count
 * @property {string} value
 * @property {boolean} selected
 */

/**
 * @typedef {object} HcpSearchResult
 * @property {string} addressLine1
 * @property {string} addressLine2
 * @property {string} city
 * @property {string} country
 * @property {string} county
 * @property {string} customerId
 * @property {string} customerName
 * @property {string} email
 * @property {string} latitude
 * @property {string} longitude
 * @property {string[]} marketCodes
 * @property {string} phoneNumber
 * @property {string} postalCode
 * @property {string[]} purchasingOptions
 * @property {{[key: string]: HcpPurchasingOption}} purchasingOptionsV2
 * @property {string} stateProvince
 * @property {string} website
 * @property {number} distance
 * @property {string} address
 */

/**
 * @typedef {object} HcpPurchasingOption
 * @property {string} hcpUrl
 * @property {string} salesChannel
 */

//#endregion

$(function () {
    //#region Fields

    // General variables.
    var isInitialized = false;
    var searchPractitionersUrl = "/api/hcpfinder/search";
    var ipFinderUrl = "/api/hcpfinder/postalcode-from-ip";
    var postalCodeFromCoordsUrl = "/api/hcpfinder/postalcode-from-coords";
    var abortController = new AbortController();

    // Element variables.
    var $buyNowModal = $("#BuyNowModal");
    var $buyNowForm = $buyNowModal.find("form");
    var $selectedPartEl = $buyNowModal.find("[name='SelectedPart']");
    var $postalCodeEl = $buyNowModal.find("[name='PostalCode']");
    var $practitionersWithinRangeEl = $buyNowModal.find("[name='PractitionersWithinRange']");
    var $loadingSpinners = $buyNowModal.find(".js-spinner-container");
    var $searchBtn = $buyNowModal.find("[name='UpdatePractionerSearchResults']");
    var $hasResultsContainer = $buyNowModal.find(".js-has-results-container");
    var $noResultsContainer = $buyNowModal.find(".js-no-results-container");
    var $practitionerResultsList = $buyNowModal.find(".js-nearest-practitioners-list");
    var $errorContainer = $buyNowModal.find(".js-error-messages-container");
    var $advancedOptionsToggleBtn = $buyNowModal.find(".js-advanced-options-toggle");
    var $buyNowAdvancedSearchContainer = $buyNowModal.find("#BuyNowAdvancedSearchContainer");
    var $resultsCollapsableContainer = $buyNowModal.find("#ResultsCollapsableContainer");
    var postalCodeEntered = null;
    var resultsForPostalCode = null;

    // Misc variables.
    var resultsCollapsableContainer = bootstrap.Collapse.getOrCreateInstance($resultsCollapsableContainer[0]);

    //#endregion

    //#region Validator

    // This will mark the element as invalid if the pattern does not match.
    // NOTE: Requires the parameters "positivePattern".
    jQuery.validator.addMethod("sp_positive_pattern", function (value, element, params) {
        if (this.optional(element) == true) {
            return true;
        }

        if ((params.positivePattern ?? "") === "") {
            return false;
        }

        const regex = new RegExp(params.positivePattern, "gim");
        const result = regex.exec(value);

        return result !== null;
    }, "Invalid characters.");

    var $validator = $buyNowForm.validate({
        onfocusout: function (element) {
            $(element).valid();
        },
        onkeyup: function (element, event) {
            if ($(element).is(".no-validate-on-key-down")) {
                return;
            }

            $.validator.defaults.onkeyup.call(this, element, event);
        },
        focuscleanup: true,
        errorElement: "label",
        errorClass: "alert-msg",
        rules: {
            SelectedPart: {
                required: true,
            },
            PostalCode: {
                required: true,
                sp_positive_pattern: {
                    positivePattern: "^[0-9]{5}$",
                },
            },
            PractitionersWithinRange: {
                required: true,
                max: 100,
                min: 5,
            },
        },
        messages: {
            PostalCode: {
                required: "Postal code is required.",
                sp_positive_pattern: "Must be a valid 5 digit postal code.",
            },
        },
        errorPlacement: function ($errorEl, $inputEl) {
            if ($inputEl.is("[type='radio']")) {
                const $validationContainer = $inputEl.closest(".custom-sp-label-wrapper").find(".validation");
                $errorEl.appendTo($validationContainer);
            } else if ($inputEl[0].id == "PostalCode") {
                $errorEl.appendTo($('#PostalCodeErrors'))
            }
            else {
                $errorEl.appendTo($inputEl.parent());
            }
        },
        highlight: function (element, errorClass, validClass) {
            const $element = $(element);
            const $phoneTypeContainer = $element.closest(".phone-types");
            const isIntendedUse = $element.is("[name='IntendedUse']");

            if ($phoneTypeContainer.length > 0) {
                if ((errorClass ?? "").length > 0) {
                    $phoneTypeContainer.addClass(errorClass);
                }

                if ((validClass ?? "").length > 0) {
                    $phoneTypeContainer.removeClass(validClass);
                }
            } else {
                if ((errorClass ?? "").length > 0) {
                    $element.addClass(errorClass);
                }

                if ((validClass ?? "").length > 0) {
                    $element.removeClass(validClass);
                }
            }

            if (isIntendedUse) {
                if ((errorClass ?? "").length > 0) {
                    $intendedUses.addClass(errorClass);
                }

                if ((validClass ?? "").length > 0) {
                    $intendedUses.removeClass(validClass);
                }
            }
        },
        unhighlight: function (element, errorClass, validClass) {
            const $element = $(element);
            const $phoneTypeContainer = $element.closest(".phone-types");
            const isIntendedUse = $element.is("[name='IntendedUse']");

            if ($phoneTypeContainer.length > 0) {
                if ((errorClass ?? "").length > 0) {
                    $phoneTypeContainer.removeClass(errorClass);
                }

                if ((validClass ?? "").length > 0) {
                    $phoneTypeContainer.addClass(validClass);
                }
            } else {
                if ((errorClass ?? "").length > 0) {
                    $element.removeClass(errorClass);
                }

                if ((validClass ?? "").length > 0) {
                    $element.addClass(validClass);
                }
            }

            if (isIntendedUse) {
                if ((errorClass ?? "").length > 0) {
                    $intendedUses.removeClass(errorClass);
                }

                if ((validClass ?? "").length > 0) {
                    $intendedUses.addClass(validClass);
                }
            }
        },
        success: function ($label) {
            // Helper for removing the error class from the custom
            // radio container.
            $label
                .closest(".custom-sp-label-wrapper")
                .find(".labelled-container.error")
                .removeClass("error");
        },
        invalidHandler: function (event, validator) {
            // Helper for adding the error class to the 
            // radio container.
            for (let errorEntry of validator.errorList) {
                var $parent = $(errorEntry.element).closest(".labelled-container");

                if ($parent.length === 0) {
                    continue;
                }

                $parent.addClass(validator.settings.errorClass);
            }
        },
    });

    //#endregion

    //#region Html Functions

    /**
     * @returns {boolean}
     */
    function validatePractionerLookupFormHtml() {
        var result = $validator.form();

        if (!result) {
            $validator.focusInvalid();
        }

        return result;
    }

    var toggleResultsCollapsable = (function () {
        var isCallbackQueued = false;
        var lastShow = false;

        /**
         * Able to toggle the collapsible even when transitioning.
         * @param {boolean} show
         * @returns {void}
         */
        return (show) => {
            lastShow = show;

            if (isCallbackQueued) {
                return;
            }

            var isTransitioning = $resultsCollapsableContainer.is(".collapsing");

            if (!isTransitioning) {
                lastShow
                    ? resultsCollapsableContainer.show()
                    : resultsCollapsableContainer.hide();
                return;
            } else {
                // Add event listener.
                $resultsCollapsableContainer.one("shown.bs.collapse hidden.bs.collapse", function (e) {
                    setTimeout(() => {
                        lastShow
                            ? resultsCollapsableContainer.show()
                            : resultsCollapsableContainer.hide();
                        isCallbackQueued = false;
                    }, 1);
                });
            }
        }
    })();

    /**
     * @param {boolean} show
     * @returns {void}
     */
    function showLoadingSpinners(show) {
        if (show) {
            $loadingSpinners.removeClass("d-none");
            $searchBtn.addClass("disabled").attr("disabled", "disabled");
            $selectedPartEl.addClass("disabled").attr("disabled", "disabled");
            $postalCodeEl.addClass("disabled").attr("disabled", "disabled");
            $practitionersWithinRangeEl.addClass("disabled").attr("disabled", "disabled");
            toggleResultsCollapsable(false);
        } else {
            $loadingSpinners.addClass("d-none");
            $selectedPartEl.removeClass("disabled").attr("disabled", null);
            $postalCodeEl.removeClass("disabled").attr("disabled", null);
            $practitionersWithinRangeEl.removeClass("disabled").attr("disabled", null);
            toggleResultsCollapsable(true);

            var hasSearchResults = $practitionerResultsList.find(".js-search-result").length > 0;

            if (hasSearchResults) {
                // Has results.
                $noResultsContainer.addClass("d-none");
                $hasResultsContainer.removeClass("d-none");
            } else {
                // No results.
                $noResultsContainer.removeClass("d-none");
                $hasResultsContainer.addClass("d-none");
            }
        }
    }

    function postalCodeFieldEnableDisable(e) {
        if ($('#PostalCode').val().length >= 5 && $('#PostalCode').val().length < 9 && $('#PostalCode').val() != resultsForPostalCode) {
            postalCodeEntered = $('#PostalCode').val();
            $searchBtn.removeClass("disabled").attr("disabled", null);
        }
        else {
            $searchBtn.addClass("disabled").attr("disabled", "disabled");
        }
    }

    /**
     * @param {HcpSearchResultsDtoPartial & { partNo: string, productSlug: string }} data
     * @returns {void}
     */
    function setAvailablePractionersHtml(data) {
        if (data === null || data === undefined) {
            throw new Error("The argument \"data\" cannot be null nor undefined.");
        }

        // Remove error messages.
        $errorContainer.html("");

        // Show error messages if any.
        if (data.errors !== null && data.errors !== undefined) {
            console.error(data.errors);
            for (var eKey in data.errors) {
                var errors = data.errors[eKey];
                // Use the bindViewModelToHtml(...) function to create the html to append to the errors container.
                var $errorEl = $(`<p class="text-danger">${errors.join("<br/>")}</p>`);
                $errorContainer.append($errorEl);
            }
        }

        // Remove all the search results.
        $practitionerResultsList.html("");

        var template = `
            <div class="js-search-result card mb-3" style="font-family: PFCentroSans;">
                <div class="card-body">
                    <div class="d-flex justify-content-between">
                        <div class="ms-2 me-auto col-7">
                            <h3 class="card-title text-16 font-weight-bold d-flex">
                                <span>{{customerName}}</span>
                            </h3>
                            <div class="card-text text-13 font-weight-bold mb-0">
                            <div>
                                <a class="btn btn-link text-start m-0 p-0" href="https://www.google.com/maps/search/?api=1&query={{gaddress}}" target="_blank">
                                    <i class="text-danger pe-2 fal fa-map-marker-alt" aria-hidden="true"></i>
                                    {{addressLine1}}
                                </a>
                                </div>
                                <div>
                                <a class="btn btn-link text-start m-0 p-0" href="https://www.google.com/maps/search/?api=1&query={{gaddress}}" target="_blank">
                                 <i class="text-danger pe-2 fal fa-map-marker-alt" style="visibility: hidden;" aria-hidden="true"></i>
                                    {{cityStateZip}}
                                </a>
                                <p class="mb-0">
                                    <i class="text-accent-1 pe-2 fal fa-car" aria-hidden="true"></i>
                                    {{distance}} mi
                                </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-5 d-flex justify-content-center align-items-center">
                            <a class="btn btn-primary" href="{{website}}" target="_blank">Order Here</a>
                        </div>
                    </div>
                </div>
            </div>`;

        for (var practitionerRecord of data.value) {
            var twWebsite = (practitionerRecord.purchasingOptionsV2 ?? [])
                .find(x => x.salesChannel === "TW")
                ?.hcpUrl ?? "";

            if (twWebsite !== "") {
                var originalTWUrl = new URL(twWebsite);
                var urlWithCorrectPath = new URL("/products/" + data.productSlug + "?partNo=" + data.partNo, originalTWUrl);
                twWebsite = urlWithCorrectPath.href;
            }
            var viewModel = {
                partNo: data.partNo,
                customerName: practitionerRecord.customerName,
                addressLine1: practitionerRecord.addressLine1 ?? "",
                cityStateZip: (practitionerRecord.city + ', ' + practitionerRecord.stateProvince + ' ' + practitionerRecord.postalCode) ?? "",
                phoneNumber: practitionerRecord.phoneNumber ?? "",
                website: twWebsite ?? "",
                distance: practitionerRecord.distance,
                gaddress: encodeURIComponent(practitionerRecord.address),
            };

            var newElStr = bindViewModelToHtml(viewModel, template);
            $practitionerResultsList.append(newElStr);
        }

        if (data.value.length === 0) {
            // Show no results.
            $noResultsContainer.removeClass("d-none");
            $hasResultsContainer.addClass("d-none");
        } else {
            // Show the results.
            $noResultsContainer.addClass("d-none");
            $hasResultsContainer.removeClass("d-none");
        }
    }

    /**
     * @param {string} postalCode
     * @returns {void}
     */
    function setPostalCodeHtml(postalCode) {
        $postalCodeEl.val(postalCode);
    }

    /**
     * @returns {{postalCode: string, range: number, partNumbers: string[], page: number, pageSize: number, isVeterinary: boolean}}
     */
    function getPractitionerLookupDataHtml() {
        var postalCode = $postalCodeEl.val();
        var range = Number.parseInt($practitionersWithinRangeEl.val());
        var partNo = $selectedPartEl.val();
        var $selectedOption = $selectedPartEl.find("option[value='" + partNo + "']");
        if ($selectedOption.length == 0) {
            $selectedOption = $('#SelectedPart');
        }

    
        var isVeterinary = $selectedOption.attr("data-is-veterinary") === "true";

        if (Number.isNaN(range)) {
            range = 5;
        }

        return {
            postalCode,
            range,
            partNumbers: [partNo],
            page: 0,
            pageSize: 5,
            isVeterinary: isVeterinary,
        };
    }

    //#endregion

    //#region Api Functions

    /**
     * @param {object} data
     * @param {boolean} data.isVeterinary
     * @param {string} data.partNo
     * @param {string} data.postalCode
     * @param {number} data.range
     * @param {number} data.page
     * @param {number} data.pageSize
     * @returns {Promise<HcpSearchResultsDto>}
     */
    function lookupPractitonersAsync(data) {
        if (data === undefined || data === null) {
            throw new Error("The argument \"data\" cannot be null nor undefined.");
        }

        var request = new Request(searchPractitionersUrl, {
            signal: abortController.signal,
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
            },
        });

        /** @type {Response|null} */
        var response = null;

        return fetch(request)
            .then(r => {
                response = r;

                if (response.ok) {
                    resultsForPostalCode = data.postalCode;
                    return response.json();
                } else {
                    var hasContentLengthHeader = response.headers.has("Content-Length");
                    var hasContentTypeHeader = response.headers.has("Content-Type");

                    if (!hasContentLengthHeader) {
                        return "Failed to determine the address from the ip address.";
                    } else if (hasContentTypeHeader && response.headers.get("Content-Type") === "application.json") {
                        return response.json();
                    } else {
                        return response.text();
                    }
                }
            })
            .then(x => {
                if (response.ok) {
                    $searchBtn.addClass("disabled").attr("disabled", "disabled");
                    return x;
                } else {
                    $searchBtn.removeClass("disabled").attr("disabled", null);
                    throw new Error(x);
                }
            });
    }

    /**
     * Retrieves the postal code of the users ip address.
     * @returns {Promise<string>}
     */
    function getCurrentPositionServerAsync() {
        var request = new Request(ipFinderUrl);

        /** @type {Request} */
        var response = null;

        return fetch(request)
            .then(r => {
                response = r;

                if (response.ok) {
                    return response.json();
                } else {
                    var hasContentLengthHeader = response.headers.has("Content-Length");
                    var hasContentTypeHeader = response.headers.has("Content-Type");

                    if (!hasContentLengthHeader) {
                        return Promise.reject(response.status);
                    } else if (hasContentTypeHeader && response.headers.get("Content-Type") === "application.json") {
                        return response.json();
                    } else {
                        return response.text();
                    }
                }
            })
            .then(x => {
                if (response.ok) {
                    return x;
                } else {
                    throw new Error(x);
                }
            });
    }

    //#endregion

    //#region Misc Functions

    /**
     * Refreshes the search results.
     */
    function refreshSearchResults() {
        var isFormValid = validatePractionerLookupFormHtml();

        if (!isFormValid) {
            return;
        }

        resetAbortController();
        showLoadingSpinners(true);
        var lookupData = getPractitionerLookupDataHtml();
        var $selectedOption = $selectedPartEl.find("option[value='" + lookupData.partNumbers[0] + "']");
        if ($selectedOption.length == 0) {
            $selectedOption = $('#SelectedPart');
        }
        var productSlug = $selectedOption.attr("data-product-slug");

        lookupPractitonersAsync(lookupData)
            .then(data => setAvailablePractionersHtml({
                ...data,
                partNo: lookupData.partNumbers[0],
                productSlug: productSlug,
            }))
            .catch(function (e) {
                if (e === "aborted") {
                    // No error handling needed.
                    return;
                }

                console.error(e);
            })
            .finally(() => showLoadingSpinners(false));
    }

    /**
     * Populates the template.
     * @param {object} viewModel Must be an object, cannot be a primitive (like
     * a string).
     * @param {string} html 
     * @returns {string}
     */
    function bindViewModelToHtml(viewModel, html) {
        let htmlCopy = html;
        const regex = /{{(.*?)}}/gi;
        const viewModelKeys = Object.keys(viewModel);

        for (let matchArr of html.matchAll(regex)) {
            const htmlKey = matchArr[0];
            const expression = "return this." + matchArr[1];
            const fnBinder = new Function(expression);
            const replacementHtml = fnBinder.call(viewModel);

            while (htmlCopy.includes(htmlKey)) {
                htmlCopy = htmlCopy.replace(htmlKey, replacementHtml);
            }
        }

        return htmlCopy;
    }

    function resetAbortController() {
        if (abortController !== null && abortController !== undefined) {
            abortController.abort("aborted");
        }

        abortController = new AbortController();
    }

    //#endregion

    //#region Event Listeners

    // This just needs to run once, so using "one" instead of "on".
    $buyNowModal.one("show.bs.modal", function (e) {
        if (isInitialized) {
            return;
        }

        isInitialized = true;
        showLoadingSpinners(true);

        getCurrentPositionServerAsync()
            .then(postalCode => {
                setPostalCodeHtml(postalCode);
                var isFormValid = $validator.form();

                if (!isFormValid) {
                    $validator.focusInvalid();
                }

                // This should not happen in the initial request but
                // should still check all the same.
                if (!isFormValid) {
                    // Short circuit.
                    throw new Error("invalid form");
                }

                var lookupData = getPractitionerLookupDataHtml();

                var $selectedOption = $selectedPartEl.find("option[value='" + lookupData.partNumbers[0] + "']");
                if ($selectedOption.length == 0) {
                    $selectedOption = $('#SelectedPart');
    }
                var productSlug = $selectedOption.attr("data-product-slug");

                return lookupPractitonersAsync(lookupData).then(x => {
                    return {
                        ...x,
                        partNo: lookupData.partNumbers[0],
                        productSlug: productSlug,
                    }
                });
            })
            .then(data => {
                resultsForPostalCode = data.postalCode
                setAvailablePractionersHtml(data);
            })
            .catch(function (e) {
                if ("message" in e && e.message === "aborted") {
                    // No error handling needed.
                    return;
                } else if ("message" in e && e.message === "invalid form") {
                    // No error handling needed.
                    return;
                }
                console.error(e);
            })
            .finally(() => showLoadingSpinners(false));
    });

    $buyNowModal.on("hide.bs.modal", function (e) {
        resetAbortController();
    });

    $searchBtn.on("click", function (e) {
        refreshSearchResults();
    });

    $selectedPartEl.on("change", function (e) {
        refreshSearchResults();
    });

    $buyNowAdvancedSearchContainer.on("hide.bs.collapse", function (e) {
        $advancedOptionsToggleBtn
            .find(".js-toggle-text")
            .text($advancedOptionsToggleBtn.data("collapsedText"));

        $advancedOptionsToggleBtn
            .find(".js-toggle-text + *")
            /*.removeClass("rotate-180");*/
            .removeClass("fa-rotate-180");
    });

    $buyNowAdvancedSearchContainer.on("show.bs.collapse", function (e) {
        $advancedOptionsToggleBtn
            .find(".js-toggle-text")
            .text($advancedOptionsToggleBtn.data("expandedText"));

        $advancedOptionsToggleBtn
            .find(".js-toggle-text + *")
            //.addClass("rotate-180");
            .addClass("fa-rotate-180");
    });

    $("#PostalCode,#PractitionersWithinRange").on("keypress", function (e) {
        if (e.key === "Enter" && $('#PostalCode').val() != resultsForPostalCode) {
            $searchBtn.trigger("click");
        }
    });



    $(document).on('blur', '#PostalCode', function (e) {
        postalCodeFieldEnableDisable(e);
    });

    $(document).on('input', '#PostalCode', function (e) {
        postalCodeFieldEnableDisable(e);
    });


    //#endregion
});